import {APPLY_VISIONHUB_FILTER, START} from "../constants/action-types";
import {FAIL, SUCCESS} from "../../../constants";

export default function visionHubState(state = false, {type}) {
  switch (type) {
    case APPLY_VISIONHUB_FILTER + START:
      return true;
    case APPLY_VISIONHUB_FILTER + FAIL:
      return false;
    case APPLY_VISIONHUB_FILTER + SUCCESS:
      return false;
    default:
      return state;
  }
}
